import Head from 'next/head';
import React, { JSX } from 'react';
import { fullPath } from 'services/shared/routerService';
import { CORPORATE } from 'services/shared/imageService';

interface PropsInterface {
	children?: React.ReactNode;
	title: string;
	description: string;
	preloadImage?: string;
}

function SEO(props: PropsInterface): JSX.Element {
	return (
		<Head>
			<title key={'title'}>{`${props.title}`}</title>
			<meta name="title" content={`${props.title}`} />
			<meta name="description" content={props.description} />

			{props.preloadImage && (
				<link rel="preload" as="image" href={props.preloadImage} {...({ fetchpriority: 'high' } as any)} />
			)}

			<meta property="og:type" content="website" />
			<meta property="og:url" content={process.env.NEXT_PUBLIC_HOST_URL} />
			<meta property="og:title" content={props.title} />
			<meta property="og:description" content={props.description} />
			<meta property="og:image" content={fullPath(CORPORATE.LOGO_OLD)} />

			<meta property="twitter:card" content="summary_large_image" />
			<meta property="twitter:url" content={process.env.NEXT_PUBLIC_HOST_URL} />
			<meta property="twitter:title" content={props.title} />
			<meta property="twitter:description" content={props.description} />
			<meta property="twitter:image" content={fullPath(CORPORATE.LOGO_OLD)} />
		</Head>
	);
}

export default SEO;
